import * as React from 'react';

import { Page, PageTitle } from '../components';

export const SettingsPage = () => (
    <Page>
        <PageTitle>Settings</PageTitle>
    </Page>
);
